<template>
<a v-if="footer" href="#" @click.prevent="$emit('sendForm')" class="btn btn-footer" :style="`background-color: ${content.color}`">
  <span>{{ content.text }}</span>
</a>
  <a v-else @click.prevent="onStart(content)"  href="#" class="btn" :style="`background-color: ${content.content.btn.color}`">
    <span>{{ content.content.btn.text }}</span>
  </a>
</template>
<script>
import {bus} from '../../../utils/bus'
export default {
  props: ["content","footer","date"],
  name: "Button",
  methods: {
    onStart(i){
      this.$gtm.trackEvent({
        event: 'lgcompromo',
        category: 'promo_map',
        eventCategory: 'promo_map',
        action: 'banner',
        eventAction: 'banner',
        label:  i.content.btn.text,
        eventLabel: i.content.btn.text,
        noninteraction: false // Optional
      });
      this.$scrollTo('#footer',
          {
            onDone: this.onDone(i)
          })
      this.$store.commit('SET_SELECTED_COUNTRY',i.country)
      this.$store.dispatch('getDistance',i.country)
      bus.$emit('scroll-to-map',i)
    },
    onDone(i){
      bus.$emit('scroll-to-map',i)
      return true
    }
  }
}
</script>

<style scoped lang="scss">
@import "button";
</style>